module.exports = __webpack_public_path__ + "static/media/323.aec2cfa7.svg";